import { render, staticRenderFns } from "./PersonAiCompanyAnalysisResult.vue?vue&type=template&id=2fc81fa6&"
import script from "./PersonAiCompanyAnalysisResult.vue?vue&type=script&lang=js&"
export * from "./PersonAiCompanyAnalysisResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports